import React, { useState, useEffect } from 'react';
// import styles from './AdvancedBasicBrownfield.module.scss';
import styles from '../../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

/*
the options object stores objects with attributes for:
  - what to label the checkbox with
  - what parameter to query for when a box is checkbox
  - the objectIds returned from the query (query is only done the first time the box is checked)
*/
const options = {
  "Assessment Grants": {
    param: "BF_ASSESS_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "Assessment Pilots": {
    param: "BF_ASSESS_PILOT_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "Cleanup Grants": {
    param: "BF_CLEANUP_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "RLF Grants": {
    param: "BF_RLF_GRANT_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "RLF Pilots": {
    param: "BF_RLF_PILOT_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "Multi Purpose Grants": {
    param: "BF_MULTIPURPOSE_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "Area-Wide Planning Grants": {
    param: "BF_AWP_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "State and Tribal 128(a) Grants": {
    param: "BF_128A_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "State and Tribal 128(a) Pilots": {
    param: "BF_128A_P_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "Showcase Community": {
    param: "BF_SHOWCASE_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  },
  "Ready for Anticipated Use": {
    param: "BF_READY_FOR_REUSE_IND = 'Y'",
    isIncluded: false,
    objectIds: null
  }
};
const AdvancedBasicBrownfield = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  /* called every time a checkbox is checked or unchecked */
  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  // updates the brownfieldParam array stored in the parent component
  const passUpdatedParams = () => {
    let paramArray: Array<string> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    props.updateBrownfieldParams(paramArray);
  }

  const buildCheckboxDivs = (clear?) => {
    let tempArr: Array<any> = [];
    if (clear) {
      // the clear button was clicked, recreate checkboxes to be all unchecked
      for (let key in options) {
        options[key]["isIncluded"] = false;
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else {
      for (let key in options) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (options[key]["isIncluded"] === true) {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
    }
    passUpdatedParams();
    setCheckboxDivArray(tempArr);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(); }, [props.matchesAny]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(true); }, [props.signalClear]);

  return (
    <div className={styles.Sections}>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Brownfield Properties</label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {checkboxDivArray}
      </div>
    </div>
  );
}
export default AdvancedBasicBrownfield;